export type Features = {
  referral: boolean;
  serviceDelivery: boolean;
};

/*
 * A list of enabled/disabled features
 */
export default function (): Features {
  const referral = process.env.REACT_APP_FEATURE_REFERRAL !== 'false';
  return {
    referral,
    serviceDelivery: true,
  };
}
